export default class Customerdetails {
    constructor() {
        this.terms = document.querySelector('#terms')
        this.button = document.querySelector('#proceed-reservation')
        this.init = this.init.bind(this)

        this.init()
    }

    init() {
        if (!this.terms) return false
        const t = new Term(this.terms)
        this.button.disabled = true
        t.el.addEventListener('click', ev => { t.handleClick(this.button) })
    }
}

class Term {
    constructor(el) {
        this.el = el
        this.checked = false

        this.handleClick = this.handleClick.bind(this)
    }

    handleClick(button) {
        this.checked = !this.checked
        button.disabled = !this.checked
    }
}
